import React from 'react';
import {
    Box,
    FormControl,
    FormGroup,
    ListItemText,
    MenuItem
} from '@mui/material';
import { ArrowLeftLinearIcon } from '../../../icons-lib';
import i18n from '../../../i18';
import Scrollbar from '../../../components/scrollbar/Scrollbar';
import CheckboxRound from '../../../components/round-checkbox';
import { getFilterField } from '../../../utils/formatName';

export const FilterExistence = ({
    filters,
    selectedFilter,
    field,
    onValueChange,
    onBack
}) => {
    const selectedFilters = filters.find(
        (f) => f.field === getFilterField(selectedFilter)
    );
    const selectedOp = selectedFilters?.op;

    const handleOptionChange = (value, op) => {
        onValueChange(value, op);
    };

    const options = [
        {
            label: field.trueLabel,
            value: null,
            op: '!='
        },
        { label: field.falseLabel, value: null, op: '=' }
    ];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <MenuItem onClick={onBack}>
                <ArrowLeftLinearIcon sx={{ mr: 2 }} />
                {i18n.t(`columns.${field.label}`)}
            </MenuItem>
            <FormControl>
                <FormGroup>
                    <Scrollbar sx={{ maxHeight: 300 }}>
                        {options.map((option) => {
                            return (
                                <MenuItem
                                    key={option.op}
                                    onClick={() =>
                                        handleOptionChange(
                                            option.value,
                                            option.op
                                        )
                                    }
                                    sx={{
                                        '&.Mui-selected': {
                                            backgroundColor: (theme) =>
                                                theme.palette.action
                                                    .mainSelected
                                        }
                                    }}
                                >
                                    <CheckboxRound
                                        checked={selectedOp === option.op}
                                    />
                                    <ListItemText
                                        primary={i18n.t(
                                            `enums.${option.label}`
                                        )}
                                        sx={{ ml: 1 }}
                                    />
                                </MenuItem>
                            );
                        })}
                    </Scrollbar>
                </FormGroup>
            </FormControl>
        </Box>
    );
};
